module.exports = require('react/lib/ReactFragment').create;


//////////////////
// WEBPACK FOOTER
// d:/documents/git/krkrsvchk/krkrsvchk_web/~/material-ui/~/react-addons-create-fragment/index.js
// module id = 344
// module chunks = 1